<template>
  <job-left-menu>
    <div class="job-left-menu__content">
      <section-separator class="group-separator" v-if="$can('admin-jobs-all')">
        {{$t('job.menu.title')}}
      </section-separator>

      <saved-filters :entity="entity"></saved-filters>

      <section-separator class="group-separator" v-if="$can('admin-jobs-all')">
        {{$t('organization.menu.title')}}
      </section-separator>
      <router-link :to="{name: organizationRoute}" class="nav-list__item" v-if="$can('admin-jobboard-all')">
        {{$t('generic.all')}}
      </router-link>
    </div>
  </job-left-menu>
</template>
<script>
  import JobLeftMenu from './JobLeftMenu'
  import SavedFilters from 'src/components/Filters/SavedFilters'
  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import entities from 'src/config/entities'

  export default {
    name: 'job-filters',
    components: {
      JobLeftMenu,
      SavedFilters
    },
    data () {
      return {
        entity: entities.JOB,
        organizationRoute: getRouteName(routeTypes.LIST, entities.ORGANIZATION),
        jobsRoute: getRouteName('jobs-filter', entities.JOB),
        jobReportsRoute: getRouteName(routeTypes.LIST, entities.JOB_REPORTS),
        jobAlertsRoute: getRouteName(routeTypes.LIST, entities.JOB_ALERT),
      }
    }
  }
</script>
<style scoped>
  .job-left-menu__content .group-separator:first-child {
    margin-top: 0;
  }
</style>
